import React, { useState, useEffect, useRef } from "react";
import { Container, Box } from "@mui/material";
import Navbar from "../components/Navbar";
import StepperProgress from "../components/parcours-client/StepperProgress";
import Footer from "../components/Footer";
import VehicleStep from "../components/parcours-client/VehicleStep";
import ClientStep from "../components/parcours-client/ClientStep";
import InsuranceStep from "../components/parcours-client/InsuranceStep";
import SerieVehicleStep from "../components/parcours-client/SerieVehicleStep";
import ReacapSubscriptionStep from "../components/parcours-client/ReacapSubscriptionStep";
import SignatureStep from "../components/parcours-client/SignatureStep";
import PaymentStep from "../components/parcours-client/PaymentStep";

const ParcoursClient = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const isNavigatingManuallyRef = useRef(false); 

  const goToStepOne = () => goToStep(0);

  const goToStep = (step) => {
    isNavigatingManuallyRef.current = true;
    setCurrentStep(step);
  };

  const [formData, setFormData] = useState({
    bikeType: "",
    marque: "",
    modele: "",
    prix: "",
    dateAchat: "",
    pesel: "",
    nom: "",
    prenom: "",
    email: "",
    telephone: "",
    typeVoie: "",
    numeroVoie: "",
    voie: "",
    numeroLocal: "",
    ville: "",
    codePostal: "",
    pays: "",
  });

  const handleNext = () => {
    const nextStep = Math.min(currentStep + 1, stepComponents.length - 1);
    isNavigatingManuallyRef.current = true;
    setCurrentStep(nextStep);
  };

  const handleBack = () => {
    const prevStep = Math.max(currentStep - 1, 0);
    isNavigatingManuallyRef.current = true;
    setCurrentStep(prevStep);
  };

  // ➕ Ajouter une entrée d'historique SEULEMENT si la navigation vient d'un bouton
  useEffect(() => {
    if (isNavigatingManuallyRef.current) {
      window.history.pushState({ step: currentStep }, "");
      isNavigatingManuallyRef.current = false;
    }
  }, [currentStep]);

  // ▶️ Initialisation
  useEffect(() => {
    // Initialiser l'historique proprement
    window.history.replaceState({ step: 0 }, "");

    const handlePopState = (event) => {
      const step = event.state?.step;
      if (typeof step === "number") {
        setCurrentStep(step);
      } else {
        setCurrentStep(0);
      }
    };

    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  const stepComponents = [
    <VehicleStep
      formData={formData}
      setFormData={setFormData}
      handleNext={handleNext}
    />,
    <ClientStep
      formData={formData}
      setFormData={setFormData}
      handleNext={handleNext}
      handleBack={handleBack}
    />,
    <InsuranceStep
      formData={formData}
      setFormData={setFormData}
      handleNext={handleNext}
      handleBack={handleBack}
    />,
    <SerieVehicleStep
      formData={formData}
      setFormData={setFormData}
      handleNext={handleNext}
      handleBack={handleBack}
      goToStepOne={goToStepOne}
    />,
    <ReacapSubscriptionStep
      formData={formData}
      setFormData={setFormData}
      handleNext={handleNext}
      handleBack={handleBack}
    />,
    <SignatureStep
      formData={formData}
      setFormData={setFormData}
      handleBack={handleBack}
      handleNext={handleNext}
    />,
    <PaymentStep
      formData={formData}
      handleBack={handleBack}
      handleNext={handleNext}
    />,
  ];

  return (
    <>
      <Navbar />
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Container sx={{ mt: 12, mb: 6 }}>
          <StepperProgress
            currentStep={currentStep}
            totalSteps={stepComponents.length}
          />
          <Box sx={{ mt: 5 }}>
            {React.cloneElement(stepComponents[currentStep], {
              ...(currentStep > 0 && { handleBack }),
            })}
          </Box>
        </Container>
        <Footer />
      </Box>
    </>
  );
};

export default ParcoursClient;